<template>
    <div>
      <BillingDialCampaign v-if="getShowBillingCampaign" />
      <PreditivaDialCampaign v-if="getShowPreditivaCampaign" />
      <ImplantacaoDialCampaign v-if="getShowImplantacaoCampaign" />
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import BillingDialCampaign from "./BillingDialCampaign.vue";
  import PreditivaDialCampaign from "./PreditivaDialCampaign.vue";
  import ImplantacaoDialCampaign from "./ImplantacaoDialCampaign.vue";
  
  export default {
    name: "DialCampaign",
    components: {
      BillingDialCampaign,
      PreditivaDialCampaign,
      ImplantacaoDialCampaign,
    },
    methods: {
      displayAppWelcomeHome(display = false) {
        const divWelcome = document.getElementById("welcome-home-screen");
        if (divWelcome) {
          divWelcome.style.display = display ? "flex" : "none";
        }
      },
    },
    computed: {
      ...mapGetters(["getShowBillingCampaign", "getShowPreditivaCampaign", "getShowImplantacaoCampaign"]),
    },
    watch: {
      getShowBillingCampaign(value) {
        this.displayAppWelcomeHome(!value);
      },
      getShowPreditivaCampaign(value) {
        this.displayAppWelcomeHome(!value);
      },
      getShowImplantacaoCampaign(value) {
        this.displayAppWelcomeHome(!value);
      },
    }
  };
  </script>